import { Types } from './types'

const initialState = {
    dataTypeNews: {
        filter: {},
        rows: []
    },
    currentRecord: null
}
const typeNewsReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_TYPE_NEWS:
            return {
                ...newState,
                dataTypeNews: action.payload
            }
        case Types.SET_RECORD:
            return {
                ...newState,
                currentRecord: action.payload
            }
        default:
            return { ...newState }
    }
}
export default typeNewsReducer
